<template>
  <div>
    <div class="main-wrapper">
      <!-- 年份选择  店铺选择 -->
      <header-select-bar v-model="formData" @change="handleHeaderChange"></header-select-bar>
      <!-- 月份选择 -->
      <div v-if="formData.year && formData.storeId">
        <month-select-bar
          ref="month"
          v-model="planTime"
          :data="formData"
          @change="handleMonthChange"
          @changeYear="addListenerYear">
        </month-select-bar>
      </div>
      <!-- Tab内容 -->
      <template v-if="formatFormData.planTime">
        <tabs-bar v-model="activeTabName" :form="formatFormData"></tabs-bar>
        <keep-alive :include="cachedComponents">
          <component 
            :is="activeComponent" 
            :form="formatFormData" 
            v-if="activeTabName"
          ></component>
        </keep-alive>
      </template>
    </div>
  </div>
</template>

<script>
import headerSelectBar from './components/headerSelectBar/headerSelectBar'
import monthSelectBar from './components/monthSelectBar/monthSelectBar'
import tabsBar from './components/tabsBar/tabsBar'
import commodity from './components/mainContent/commodity/commodity'
import product from './components/mainContent/product/product'

export default {
  name: 'NewProductPreSale',
  components: {
    headerSelectBar,
    monthSelectBar,
    tabsBar,
    commodity,
    product
  },
  data() {
    return {
      formData: {
        year: new Date().getFullYear()
      },
      planTime: null,
      activeTabName: '',
      cachedComponents: []
    }
  },
  computed: {
    activeComponent() {
      if(this.activeTabName) {
        return this.activeTabName
      }else{
        return ''
      }
    },
    formatFormData() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData['planTime'] = this.planTime;
      delete formData['year']
      return formData
    }
  },
  watch: {
    activeTabName(val) {
      if(this.cachedComponents.indexOf(val) == -1) {
        this.$nextTick(() => {
          this.cachedComponents.push(val)
        });
      }
    }
  },
  methods: {
    // 监听事件 日期、平台change
    handleHeaderChange(data) {
      this.cachedComponents = [];
      this.$bus.$emit('monthRefresh', null);
      setTimeout(_=>{
        this.$bus.$emit('refresh', null);
      },300)
    },
    // 监听事件 月份change
    handleMonthChange(data) {
      setTimeout(_=>{
        this.$bus.$emit('refresh', null);
      },300)
      this.cachedComponents = [];
    },
    // 监听事件 跨年份
    addListenerYear(status) {
      if(status){
        this.$set(this.formData, 'year', +this.formData.year+1);
      }else{
        this.$set(this.formData, 'year', +this.formData.year-1);
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main-wrapper
    height calc(100vh - 85px)
    padding 10px
    box-sizing border-box

  >>> .el-container
    background #ffffff

  .empty-ele
    height 500px
    background #ffffff
</style>
